import styled from '@emotion/styled'
import { css } from '@emotion/react'

export const SectionInfoPagamentoGeral = styled.section`
  padding: 1em 0 2em 0;

  ${({ darkTheme }) =>
    darkTheme &&
    css`
      background-color: #141723;

      span,
      strong {
        color: #fff !important;
      }
    `}

  @media (max-width: 480px) {
    padding-top: 32px;
  }
`
export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 16px 32px;
  width: 100%;

  padding: 0 32px;

  @media (max-width: 1023px) {
    padding: 0 40px;
  }

  @media (max-width: 768px) {
    padding: 0 12px;
  }
`
export const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 18.4375rem;
  height: 5.875rem;
  border: 1px solid #0d71f0;
  border-radius: 8px;

  @media (max-width: 480px) {
    margin: 0;
    width: 100%;
    height: 100%;
    border: none;
    justify-content: left;
    gap: 4px;
  }
`
export const IconContainer = styled.div``

export const Image = styled.img`
  @media (max-width: 480px) {
    max-width: 21.07px;
  }
`
export const Text = styled.div`
  span {
    font-size: 1rem;
    color: #363843;
    margin: 0;
    font-weight: 400;
  }

  strong {
    font-size: 1rem;
    color: #363843;
    font-weight: 700;
  }

  span strong {
    display: block;
  }

  @media (max-width: 480px) {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;
    font-size: 0.875rem;
    font-weight: 400;
    margin: 0px;

    span,
    strong {
      font-size: 0.875rem;
      margin: 0;
    }

    span strong {
      display: initial;
    }
  }
`

export const TextBold = styled.strong`
  display: inline !important;

  @media (min-width: 30.0625rem) {
    ::after {
      content: '';
      display: block;
    }
  }
`
